import React, { Component } from 'react';
import Classnames from 'classnames';
import { ascending, descending } from 'd3';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import ReactTooltip from 'react-tooltip';
import Footnote from "../Footnote";

import './style.css';

export default class extends Component {
  
  constructor(props){
    super(props);
    this.rerunAnalysis = this.rerunAnalysis.bind(this);
  }

  rerunAnalysis(key){
    if(this.props.investmentGoal !== key){
      this.props.setAwaitingNewData(true);
      this.props.setInvestmentGoal(key)
      this.props.runAnalysis(true);
    }
  }

  render () {
    const { 
      compareMode, 
      metrics, 
      original, 
      proposed, 
      commonPeriodStart, 
      commonPeriodEnd, 
      asOfDate,
      TEXT,
      originalPortfolioLabel,
      proposedPortfolioLabel,
    } = this.props;
    const { getCleanDate } = this.props;

    return (
      <table className="key-metrics">
        <thead>
          <tr>
            <th />
            <th className="original version-heading">{originalPortfolioLabel} 
              {/* <div>
                <FontAwesomeIcon 
                  className='add-to-my-portfolios'
                  icon="folder-plus" 
                  size="lg" 
                  data-tip 
                  data-for={'add-to-my-portfolios'}/>
              </div> */}
            </th>
            <th className="proposed version-heading">{proposedPortfolioLabel} 
              {/* <div>
                <FontAwesomeIcon 
                  className='add-to-my-portfolios'
                  icon="folder-plus" 
                  size="lg" 
                  data-tip 
                  data-for={'add-to-my-portfolios'}/>
              </div> */}
            </th>
          </tr>
          <tr>
            <th colSpan={3} className="border"></th>
          </tr>
        </thead>

        {metrics.map((metric,i) => {
          const comparison =
            metric.bounds &&
            (metric.bounds[1] > metric.bounds[0] ? ascending : descending)(
              original[metric.value],
              proposed[metric.value]
            );

          return (
            <tbody key={metric.value} className={"key-metric key-metric-"+metric.key}>
              <tr>
                <td rowSpan={2} className={Classnames("title",{
                  "small": metric.key === "S"
                })}>
                  <div className="key-metric-heading">{metric.title}</div>
                  <div className={"key-metric-button" + (i===0 ? " disabled" : "")}>
                    {!compareMode && <button onClick={() => { this.rerunAnalysis(metric.key) }}>
                      {(i===0 ? TEXT.optimizeForThisLabel : TEXT.optimizeLabel)}
                    </button>}
                  </div>
                </td>
                <td
                  className={Classnames('original', 'figure', {
                    winning: comparison > 0,
                  })}
                >
                  {(original[metric.value] * metric.multiplier).toFixed(metric.precision)}
                </td>
                <td
                  className={Classnames('proposed', 'figure', {
                    winning: comparison < 0,
                  })}
                >
                  {(proposed[metric.value] * metric.multiplier).toFixed(metric.precision)}
                </td>
              </tr>
              <tr>
                <td colSpan={2} className="subtitle">
                  {metric.subtitle}
                  {<Footnote mark={<span className="q" />}>
                    {metric.footnote
                      .replace("[[ASOFDATE]]", getCleanDate(asOfDate))
                      .replace("[[FROMDATE]]", getCleanDate(commonPeriodStart))
                      .replace("[[TODATE]]", getCleanDate(commonPeriodEnd))}
                  </Footnote>}
                </td>
              </tr>
              <tr>
                <td colSpan={3} className="border"></td>
              </tr>
            </tbody>
          );
        })}
      </table>)

  }
}



// WEBPACK FOOTER //
// ./src/components/KeyMetrics/Component.js